<template>
  <div style="padding: 15px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-col :span="24">
        <el-form-item label="预付金额">
          <el-input v-model="form.totalAmount" :disabled="true" />
        </el-form-item>
      </el-col>
      <el-col :span="20">
        <el-form-item label="获取验证码" prop="smsCode">
          <el-input v-model="form.smsCode" maxlength="20" placeholder="请输入验证码" />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-light">
          <!-- <span v-show="show" @click="getCode" class="smscode">获取验证码</span> -->
          <el-button v-show="show" type="primary" round size="small" @click="getCode">获取验证码</el-button>
          <span v-show="!show" class="count">{{ count }} s</span>
        </div>
      </el-col>
      <el-col :span="24">
        <el-form-item>
          <el-button type="primary" @click="funcSubmit()">确定</el-button>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import { obtainPrepayApplyAgain, obtainPrepayConfirmAgain } from "@/api/InternetBanking";
export default {
  name: "CashMoney",
  data() {
    return {
      show: true,
      count: "",
      loading: false,
      updating: false,
      tableData: [],
      row: {},
      form: {
        totalAmount: "",
        code: "",
        smsCode: ""
      },
      Pagingconf: [],
      rules: {
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  methods: {
    getInfo(row) {
      this.count = 0;
      this.form.totalAmount = row.totalAmount;
      this.form.code = row.code;
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.updating = true;
          const rLoading = this.openLoading();
          obtainPrepayConfirmAgain(this.form).then(
            response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("hideModel");
            },
            () => (this.updating = false)
          );
        } else {
          return false;
        }
      });
    },
    //获取验证码
    getCode() {
      if (this.form.code == "") {
        this.$message({
          message: "请输入预付现金",
          type: "warning"
        });
      } else {
        const rLoading = this.openLoading();
        obtainPrepayApplyAgain(this.form).then(response => {
          rLoading.close();
          this.$message({
            message: response.msg,
            type: "success"
          });
          if (response.status == 0) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.count,
.smscode {
  height: 40px;
  line-height: 40px;
  display: block;
  padding-left: 5px;
}
</style>